import { render, staticRenderFns } from "./ConfusedLogo.vue?vue&type=template&id=6934e930&scoped=true"
import script from "./ConfusedLogo.vue?vue&type=script&lang=js"
export * from "./ConfusedLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6934e930",
  null
  
)

export default component.exports